import { connect } from 'react-redux'
import { compose, withProps, lifecycle } from 'recompose'
import { getPageLocation } from 'selectors'
import { isFromInvalidStorePage } from './helpers'
import { showGenericMessageModal } from 'components/GenericMessageModal/actions'
import StoreLocatorPage from './StoreLocatorPage'

const mapStateToProps = state => ({
  currentUrl: getPageLocation(state)
})

const withFromInvalidStorePage = withProps(
  ({
    currentUrl: {
      search = ''
    } = {}
  }) => ({
    isFromInvalidStorePage: isFromInvalidStorePage({ search })
  })
)

const withLifecycle = lifecycle({
  componentDidMount() {
    const { isFromInvalidStorePage, showGenericMessageModal } = this.props
    isFromInvalidStorePage && showGenericMessageModal({
      text: 'This store page could not be found. Please search for another store using your location.'
    })
  }
})

export default compose(
  connect(mapStateToProps, { showGenericMessageModal }),
  withFromInvalidStorePage,
  withLifecycle
)(StoreLocatorPage)

export { StoreLocatorSearchMain, StoreLocatorSearchSummary } from './components'
